export default __webpack_public_path__ + "static/media/order_5.b5d45ed5.svg";